/*
 * View for the topic publish modal
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicPublishModal/template/topicPublishModalTemplate.html",
], function (Marionette, TopicPublishModalTemplate) {
  var TopicPublishModalView = {};

  TopicPublishModalView.topicPublishModalLayout = Marionette.Layout.extend({
    template: TopicPublishModalTemplate,
    regions: {
      pendingResponseList: "#pendingResponseList",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
      "click #selectAllButton": "selectAll",
      "click #deselectAllButton": "deselectAll",
    },
    hideError: function () {
      this.$el.find("#pendingResponseError").hide();
    },
    showError: function () {
      this.$el.find("#pendingResponseError").attr("data-i18n", "topic.publish.error").i18n().show();
    },
    hideWarning: function () {
      this.$el.find("#pendingResponseError").hide();
    },
    showWarning: function () {
      this.$el
        .find("#pendingResponseError")
        .attr("data-i18n", "topic.publish.disabled")
        .i18n()
        .show();
    },
  });

  return TopicPublishModalView;
});
